<template>
  <KModal
    v-model:visible="isVisible"
    header="Continue with Single Sign-On"
    id="create-account-sso-modal"
  >
    <div class="modal-content">
      <p>
        The organization associated with the provided email address uses Single Sign-On (SSO) to
        sign in to CareerSafe.
      </p>
      <br />
      <p>You can access CareerSafe through your organization's portal.</p>

      <div class="button-row">
        <KButton
          id="create-account-sso-modal__button--cancel"
          label="Acknowledge"
          primary
          @click="hideModal"
        />
      </div>

      <div v-if="showContinueLink" class="continue-link-container">
        <hr />
        Don't want to sign in with SSO?
        <br />
        <button id="create-account-sso-modal__button--continue" @click="continueClicked">
          Continue Creating Account
        </button>
      </div>
    </div>
  </KModal>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { KModal, KButton } from "@k2united/frontend_components";

defineProps<{
  showContinueLink: boolean;
}>();

const emit = defineEmits(["onContinueDespiteSsoWarning"]);

const isVisible = ref(false);

const continueClicked = () => {
  hideModal();
  emit("onContinueDespiteSsoWarning");
};

const hideModal = () => {
  isVisible.value = false;
};

const showModal = () => {
  isVisible.value = true;
};

defineExpose({
  hideModal,
  showModal
});
</script>

<style scoped lang="scss">
.button-row {
  margin-top: 1.5rem;
  text-align: center;
  .k-button {
    display: inline-block;
  }
}
.continue-link-container {
  @include body-small;
  margin-top: 1.5rem;
  text-align: center;
  hr {
    margin-bottom: 1rem;
  }
  #create-account-sso-modal__button--continue {
    color: $color-link-default;
    text-decoration: underline;
  }
}
</style>
